import SwitchTheme from "./switch-theme.js";
export default SwitchTheme;